import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AssetSearchCriteriaModel } from '@app/core/models/assets/asset-search-criteria.model';
import { AssetTypeModel } from '@app/core/models/assets/asset-type.model';
import { ReferentialItem } from '@app/core/models/shared/referential-item.model';
import { AssetService } from '@app/core/services/asset.service';
import { MultiSelectModel } from '@app/shared/models/multi-select.model';
import * as _ from 'lodash';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-invoice-select-ref1',
  templateUrl: './invoice-select-ref1.component.html',
  styleUrls: ['./invoice-select-ref1.component.scss']
})
export class InvoiceSelectRef1Component implements OnInit {

  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  dropDownSettingsAssets: IDropdownSettings = {};
  dropDownDataAssets = [];

  selectedAsset = [];
  assetsSearchEventSubject: Subject<string> = new Subject<string>();
  assetSearchEvent$: Subject<[string, AssetTypeModel]> = new Subject<[string, AssetTypeModel]>();

  public assetSearchedName: string;

  ref1DetailForm: UntypedFormGroup;

  constructor(
    private dialogRef: MatDialogRef<InvoiceSelectRef1Component>,
    public dialog: MatDialog,
    private multiSelectModel: MultiSelectModel,
    private formBuilder: UntypedFormBuilder,
    private assetService: AssetService) { }

  ngOnInit(): void {
    this.dropDownSettingsAssets = this.multiSelectModel.getSettings('Label', 'Label', true, true);
    this.dropDownSettingsAssets.allowRemoteDataSearch = true;
    this.dropDownSettingsAssets.closeDropDownOnSelection = true;

    this.ref1DetailForm = this.formBuilder.group({
      PrimaryReference: new UntypedFormControl({
        value: [this.selectedAsset]
      }, [Validators.required])
    });

    this.assetSearchEvent$
    .pipe(
        debounceTime(250),
        distinctUntilChanged(),
        tap(filterData => {
            if (!_.isNil(filterData)) {
                this.assetSearchedName = filterData[0];
                this.assetService.getPagedAssetsByType({
                    Reference: this.assetSearchedName,
                    AssetTypes: !_.isNil(filterData[1]) ? [filterData[1]] : undefined
                } as AssetSearchCriteriaModel, 'Label', 'asc', 0, 30)
                    .subscribe(data => {
                        this.onAssetFetched(data.Items);
                    });
            }
        })).pipe(takeUntil(this.unsubscribe$)).subscribe();
  }

  public onAssetFilterChange(data: string, assetTypes?: AssetTypeModel) {
    this.assetSearchEvent$.next([data, assetTypes]);
  }

  onAssetFetched(assets: ReferentialItem[]) {
    this.dropDownDataAssets = assets;
  }

  close() {
    this.dialogRef.close(null);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

  onSubmit(): void {
    this.dialogRef.close(this.selectedAssetReference);
  }

  get selectedAssetReference(): ReferentialItem {
    if (_.isEmpty(this.selectedAsset) )
    {
      return null;
    }

    const label = _.head(this.selectedAsset)['Label'];
    const selectedAsset = [...this.dropDownDataAssets.filter(c => c.Label == label)][0];

    return (selectedAsset);
  }
}
